import React, { useMemo } from 'react';
import { CheckCircle, XCircle, AlertCircle, Clock } from 'react-feather';
import { Badge, Card, CardBody, Col, Row } from 'reactstrap';
import dayjs from 'dayjs';
import {
  RESULT_STATUS,
  STATUS_SUBMISSION,
  UNIT_STATUS,
  UNIT_STATUS_TOOL_TIP,
  USER_ROLES,
} from 'constants/constants';
import theme from 'constants/theme';

import { useUnit } from 'hooks/units/index';
import { formatNumeric } from 'helpers/index';
import ResultItem from './ResultItem/ResultItem';
import ButtonCompleted from '../../Content/Complete/ButtonCompleted';
import styles from 'styles/Unit.module.scss';
import TrackingResultNew from '../../Content/Complete/AssigmentComplete/TrackingResultNew';
import moment from 'moment';
import { getViewMode } from 'store/auth';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import { IoLogoModelS, IoMdArrowDropright } from 'react-icons/io';
import {
  MdExtension,
  MdHelp,
  MdOutlineTimer,
  MdReviews,
  MdScore,
  MdTimer,
} from 'react-icons/md';
import { RiTimerFill } from 'react-icons/ri';
import { showDurationTime } from 'helpers';
import { Item } from 'semantic-ui-react';
const Stylescal = styled.div`
  .checkbox-wrapper-31 {
    position: relative;
    display: inline-block;
    width: 35px;
    height: 35px;
    cursor: pointer;
  }

  .checkbox-wrapper-31 .background {
    fill: #ccc;
    transition: all 0.6s ease;
  }
  .out_border {
    border: 1px solid #e6f4f7;
  }
  .header_Stronger {
    font-size: 22px;
    font-weight: 700 !important;
  }
  .fortiming {
    font-size: 14px;
    color: #9a9da2;
    margin-top: 6px;
  }
  .result-Border {
    border: 1px solid#EAFBFF;
    background-color: #eafbff;
    margin-top: 3px;
    padding: 5px;
    font-size: 14px;
    max-width: 201px;
  }
  .for-big-border {
    border: 1px solid #daedf3;
    border-radius: 10px;
    height: 66px;
    min-width: 150px;
    max-width: max-content;
    overflow: hidden;
    // margin: -1px;

    // width: 200px;
    // height: 75px;
  }
  .for-small {
    border: 1px solid #daedf3;
    background-color: var(--course-detail-action-hover-bg-clr);
    max-height: 29px;
    // padding-right: 29px;
    text-align: center;

    // max-width: 39px;
  }
  .fornumPer {
    font-weight: 700;
    font-size: 16px;
    text-align: start;
  }
  .spacing-width {
    padding: 5px;
  }
  .red-Border {
    // border: 1px solid #e69f9f;
    width: 550px;
    padding-top: 10px;
    height: 76px;
  }

  .per-centage {
    background-color: #e1f1f2;
    margin-left: 10px;
    height: 25px;
    width: 49px;
    color: #64666b;
    border-radius: 4px;

    padding-top: 2px;
  }
  .detials {
    text-align: left;
    font-weight: 900;
  }
  .card-label {
    color: #9fa3ac;
  }
  .for-padding {
    padding-left: 6px;
  }
  .icon-space {
    transform: translate(-8px, -1px);
    color: red;
  }

  .for-item-label {
    text-align: start;
  }
  .for-gap {
    gap: 25px;
  }
`;
const ContentResult = () => {
  const unitSelected = useUnit();
  const viewMode = useSelector(getViewMode);

  const config = unitSelected?.config;

  const isFailed = unitSelected?.results?.find(
    (result) => result?.status === UNIT_STATUS.FAILED,
  );

  const isShowResult =
    unitSelected?.results?.findIndex((result) => result?.title) !== -1;
  const resultStatus =
    unitSelected?.status === UNIT_STATUS.PENDING
      ? unitSelected?.oldStatus
      : unitSelected?.status;

  const markingStatus =
    (config?.manualMarking?.status ||
      unitSelected?.results?.some(
        (dt) => dt?.questionManualMarking && dt?.status === UNIT_STATUS.PENDING,
      )) &&
    unitSelected?.status === UNIT_STATUS.PENDING;

  const now = moment();
  const isAfterDate =
    viewMode === USER_ROLES.LEARNER &&
    unitSelected?.time?.end &&
    now.isAfter(moment(unitSelected?.time?.end));

  const isAdaptive = unitSelected?.adaptiveSetup?.isAdaptive;

  /** Adaptive APIs may omit aggregate points/totals; derive from per-question results (each has weight / userWeight). */
  const adaptiveAggregates = useMemo(() => {
    const results = unitSelected?.results ?? [];
    if (!isAdaptive || !results.length) {
      return {
        totalWeight: null,
        totalUserWeight: null,
        scorePercent: null,
      };
    }
    let totalWeight = 0;
    let totalUserWeight = 0;
    for (const r of results) {
      if (r?.status === RESULT_STATUS.NOTASSIGNED) continue;
      const w = Number(r?.weight);
      const weight = Number.isFinite(w) && w > 0 ? w : 1;
      totalWeight += weight;
      const uw = r?.userWeight;
      if (typeof uw === 'number' && !Number.isNaN(uw)) {
        totalUserWeight += uw;
      }
    }
    const scorePercent =
      totalWeight > 0 ? (totalUserWeight / totalWeight) * 100 : null;
    return { totalWeight, totalUserWeight, scorePercent };
  }, [isAdaptive, unitSelected?.results]);

  const showScoreStats =
    !markingStatus &&
    (typeof unitSelected?.points === 'number' ||
      (isAdaptive &&
        adaptiveAggregates.totalWeight != null &&
        adaptiveAggregates.totalWeight > 0));

  const displayScorePercent = isAdaptive
    ? adaptiveAggregates.scorePercent != null
      ? adaptiveAggregates.scorePercent.toFixed(0)
      : null
    : typeof unitSelected?.points === 'number'
    ? unitSelected.points.toFixed(0)
    : null;

  const useAdaptiveResultWeights =
    isAdaptive &&
    adaptiveAggregates.totalWeight != null &&
    adaptiveAggregates.totalWeight > 0;

  const displayTotalUserWeight = useAdaptiveResultWeights
    ? adaptiveAggregates.totalUserWeight
    : unitSelected?.totalUserWeight;
  const displayTotalWeight = useAdaptiveResultWeights
    ? adaptiveAggregates.totalWeight
    : unitSelected?.totalWeight || 5;

  const arrayConstant = [
    ...(showScoreStats && displayScorePercent != null
      ? [
          {
            id: 1,
            icon: <MdOutlineTimer size={18} />,
            value: <>{displayScorePercent}%</>,
            label: (
              <Stylescal>
                <div className="card-label">Score</div>{' '}
              </Stylescal>
            ),
          },
        ]
      : []),

    ...(!markingStatus
      ? [
          {
            id: 2,
            icon: <RiTimerFill size={18} />,
            value: (
              <>
                {isAdaptive
                  ? '1m 40s'
                  : unitSelected?.duration
                  ? showDurationTime(unitSelected?.duration)
                  : '--'}{' '}
              </>
            ),
            label: (
              <Stylescal>
                <div className="card-label">Time Taken</div>{' '}
              </Stylescal>
            ),
          },
        ]
      : []),

    ...(!markingStatus
      ? [
          {
            id: 3,
            icon: <MdExtension size={18} />,
            value: <>{unitSelected?.Attempts ? unitSelected?.Attempts : 1}</>,
            label: (
              <Stylescal>
                <div className="card-label">No. Of Attempts</div>
              </Stylescal>
            ),
          },
        ]
      : []),

    ...(showScoreStats
      ? [
          {
            id: 4,
            icon: <MdOutlineTimer size={18} />,
            value: (
              <>
                {displayTotalUserWeight ?? 0}/{displayTotalWeight ?? 5}
              </>
            ),
            label: (
              <Stylescal>
                <div className="card-label">Weightage</div>{' '}
              </Stylescal>
            ),
          },
        ]
      : []),

    ...(!markingStatus && unitSelected?.status
      ? [
          {
            id: 3,
            icon: <MdReviews size={18} />,
            value: (
              <>
                {unitSelected?.status === UNIT_STATUS.COMPLETED
                  ? UNIT_STATUS_TOOL_TIP.COMPLETED
                  : UNIT_STATUS_TOOL_TIP.FAILED}
              </>
            ),
            label: (
              <Stylescal>
                <div className="card-label">Status</div>
              </Stylescal>
            ),
          },
        ]
      : []),
  ];

  return (
    <Card style={{ zIndex: 1, marginTop: '4%' }}>
      <CardBody className="custom_cardbody_padding">
        <div className="text-center Roboto-Font">
          {/* {resultStatus === UNIT_STATUS.FAILED ? (
            <XCircle size={100} color={theme.danger} />
          ) : resultStatus === UNIT_STATUS.COMPLETED ||
            resultStatus === STATUS_SUBMISSION.GRADED ? (
            <CheckCircle size={100} color={theme.success} />
          ) : (
            <Clock size={100} color={theme.warning} />
          )} */}

          <Stylescal>
            <Row className="out_border p-3 pb-1">
              <Col>
                <Row>
                  <Col className=" ">
                    {markingStatus && (
                      <p className="mt-1">
                        <Badge color="light-warning">Pending for Review</Badge>
                      </p>
                    )}
                  </Col>
                </Row>

                <Row>
                  <Col className="header_Stronger  mt-1">
                    {config?.completion?.stats && markingStatus
                      ? 'Submitted'
                      : 'Completed'}
                  </Col>
                </Row>

                <Row>
                  <Col className="fortiming">
                    {config?.completion?.stats &&
                      dayjs(unitSelected?.end_time).format('DD/MM/YYYY, HH:mm')}
                  </Col>
                </Row>
                {/* {!markingStatus && (
                  <Row>
                    <Col className="d-flex mt-1  justify-content-center">
                      <div className="result-Border px-2 ">
                        Your Result Is Here
                      </div>
                    </Col>
                  </Row>
                )} */}

                <Row className="d-flex  justify-content-around mt-1 for-gap">
                  {arrayConstant.map((Item) => (
                    // </Col>
                    <Col key={Item.id} className="for-big-border">
                      <Row>
                        <Col md={3} className="for-small ">
                          {Item.icon}
                        </Col>
                        <Col className="fornumPer">{Item.value}</Col>
                      </Row>
                      <Row>
                        <Col md={3}></Col>
                        <Col className="for-item-label">{Item.label}</Col>
                      </Row>
                    </Col>
                  ))}
                </Row>

                {!markingStatus && config?.detuction?.status && (
                  <Row className="red-Border  mt-2">
                    <div className="d-flex">
                      <div>
                        {/* <IoMdArrowDropright className="icon-space" size={22} />{' '} */}
                      </div>{' '}
                      <span className="detials">Details</span>
                    </div>
                    <Row>
                      <Col>
                        {' '}
                        <div className="d-flex">
                          {/* <div className="">
                            Score Taken - Late Submission = Total Score
                          </div> */}

                          <div className="">
                            Final Score = Score Obtained - Late Submission
                          </div>

                          {/* <div className="d-flex">
                            <div className="per-centage">
                              {unitSelected?.oldPoints
                                ? Math.round(unitSelected?.oldPoints)
                                : 0}
                              %
                            </div>
                            <div className="for-padding">-</div>

                            <div className="per-centage">
                              {unitSelected?.penalty ?? 0}%
                            </div>
                            <div className="for-padding">=</div>

                            <div className="per-centage">
                              {unitSelected.points
                                ? Math.round(unitSelected.points)
                                : 0}
                              %
                            </div>
                          </div> */}

                          <div className="d-flex">
                            <div className="per-centage">
                              {unitSelected.points
                                ? Math.round(unitSelected.points)
                                : 0}
                              %
                            </div>
                            <div className="for-padding">=</div>
                            <div className="per-centage">
                              {unitSelected?.OldPoints
                                ? Math.round(unitSelected?.OldPoints)
                                : 0}
                              %
                            </div>
                            <div className="for-padding">-</div>
                            <div className="per-centage">
                              {unitSelected?.penalty ?? 0}%
                            </div>
                          </div>

                          {/* <div className="d-flex">
                            <div className="per-centage">
                              {unitSelected.OldPoints
                                ? Math.round(unitSelected.OldPoints)
                                : 0}
                              %
                            </div>
                            <div className="for-padding">-</div>
                            <div className="per-centage">
                              {unitSelected?.penalty
                                ? Math.round(unitSelected?.penalty)
                                : 0}
                              %
                            </div>
                            <div className="for-padding">=</div>
                            <div className="per-centage">
                              {unitSelected?.points
                                ? Math.round(unitSelected?.points)
                                : 0}
                              %
                            </div>
                          </div> */}
                        </div>
                      </Col>
                    </Row>
                  </Row>
                )}
              </Col>
            </Row>
          </Stylescal>
          <br />
          {/* {markingStatus && (
            <p className="mt-1">
              <Badge color="light-warning">Pending for Review</Badge>
            </p>
          )}
          {config?.completion?.stats && (
            <p className="mt-2 font-medium-1 font-weight-semi-bold">
              {markingStatus
                ? 'You submitted this test on'
                : 'You completed this test on'}{' '}
              {dayjs(unitSelected?.end_time).format('DD/MM/YYYY, HH:mm')}
            </p>
          )}

          {config?.completion?.stats && !markingStatus && (
            <p>
              Out of {unitSelected?.totalUsers} person who took the test, you
              ranked {formatNumeric(unitSelected?.stats)}
            </p>
          )}

          {typeof unitSelected?.points === 'number' && !markingStatus && (
            <p className="font-medium-1">
              <b>
                Your score is {unitSelected?.points.toFixed(0)}%
                {config?.scores
                  ? `, while the average test score is ${config?.scores}%`
                  : ''}
                {`, with a weight of ${
                  unitSelected?.totalUserWeight ?? 0
                } out of
                ${unitSelected?.totalWeight ?? 0}`}
                .
              </b>
            </p>
          )} */}

          {/* {config?.stats && !markingStatus && (
            <p>
              Out of {unitSelected?.totalUsers} people that took the test, you
              rank {formatNumeric(unitSelected?.stats)}
            </p>
          )} */}

          {/* {typeof unitSelected?.points === 'number' && !markingStatus && (
            <p>
              Your score is {unitSelected?.points.toFixed(0)}%
              {config?.scores
                ? `, while the average test score is ${config?.scores}%`
                : ''}
            </p>
          )} */}

          {/* {config?.message && (
            <p className={styles.description}>{config?.message}</p>
          )} */}
          {!markingStatus && isAfterDate ? (
            <p style={{ color: 'rgb(252, 52, 52)' }}>
              This lesson expired on{' '}
              <strong>
                {moment(unitSelected?.time?.end).format('MMMM Do YYYY, h:mm A')}
              </strong>{' '}
            </p>
          ) : (
            <ButtonCompleted />
          )}
          {isFailed && config?.repetitionsNo && !markingStatus && (
            <p className="mb-0 mt-1">
              You can reattempt this test{' '}
              {config?.repetitionsNo === 1
                ? 'one more time'
                : `up to ${config?.repetitionsNo} more times`}
            </p>
          )}
        </div>
        {!markingStatus && <TrackingResultNew type="TEST" />}
        {isShowResult && (
          <>
            {/* <hr /> */}
            <div>
              {unitSelected?.results?.map((result, index) => (
                <ResultItem
                  key={result?._id}
                  result={result}
                  index={index}
                  isEnd={index === unitSelected?.totalQuesiton - 1}
                />
              ))}
            </div>
          </>
        )}
      </CardBody>
    </Card>
  );
};

export default ContentResult;
